"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PasswordStrength = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const lib_1 = require("../../lib");
const passwordTypes = ['very weak', 'weak', 'average', 'strong', 'very strong'];
const passwordModifiers = [
    '--very-weak',
    '--weak',
    '--average',
    '--strong',
    '--very-strong'
];
const tests = {
    numeric: (password) => /\d/.test(password),
    lowercase: (password) => /[a-z]/.test(password),
    capital: (password) => /[A-Z]/.test(password),
    character: (password) => /[\W]/.test(password),
    length: (password) => (password ? password : '').length >= 12
};
const calcPasswordStrength = (password) => !password || password.length === 0
    ? 0
    : Object.keys(tests).reduce((value, current) => tests[current](password) ? (value += 1) : value, 0);
const PasswordStrength = ({ password }) => {
    const strength = calcPasswordStrength(password);
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "password__strength-wrapper" }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: "password__strength" }, { children: Array.apply(null, new Array(5)).map((e, idx) => ((0, jsx_runtime_1.jsx)("div", { className: (0, lib_1.classnames)('password__strength-indicator', strength >= idx + 1
                        ? `password__strength-indicator${passwordModifiers[strength - 1]}`
                        : null) }, idx))) }), void 0), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: (0, lib_1.classnames)('password__strength-text', strength
                    ? `password__strength-text${passwordModifiers[strength - 1]}`
                    : null) }, { children: strength ? passwordTypes[strength - 1] : ' ' }), void 0)] }), void 0));
};
exports.PasswordStrength = PasswordStrength;
//# sourceMappingURL=PasswordStrength.js.map